<!--
 * @Author: zhangjingqing
 * @Date: 2022-05-29 19:49:04
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2024-10-12 10:29:23
 * @Description: file content
 * @FilePath: \sample_repository\src\views\userManage\user\UserModalEdit.vue
-->
<template>
  <a-modal
    title="编辑人员"
    :width="800"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    okText="确认"
    @ok="handleSave"
    @cancel="handleCancel"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
      <a-descriptions title="基本信息" :column="3"> </a-descriptions>
      <a-form-item label="ID">
        <a-input
            v-decorator="[
            'id',
            {
              rules: [{ required: true, message: '企业名称不能为空' }],
              trigger: 'blur',
            },
          ]"
            :read-only="true"
            class="custom-gray-input"
        />
      </a-form-item>
      <a-form-item label="账号">
        <a-input
          v-decorator="[
            'contactEmail',
            {
              rules: [{ validator: this.handleAccount }],
              trigger: 'blur',
            },
          ]"
          :read-only="true"
          class="custom-gray-input"
        />
      </a-form-item>
      <a-descriptions title="人员企业信息" :column="3"> </a-descriptions>
      <a-form-item label="企业名称">
        <a-input
          v-decorator="[
            'companyName',
            {
              rules: [{ required: true, message: '企业名称不能为空' }],
              trigger: 'blur',
            },
          ]"
          placeholder="请输入企业名称"
          :read-only="true"
          class="custom-gray-input"
        />
      </a-form-item>
      <a-form-item label="联系人">
        <a-input
          v-decorator="[
            'contactPerson',
            {
              rules: [{ required: true, message: '联系人不能为空' }],
              trigger: 'blur',
            },
          ]"
          placeholder="请输入联系人"
        />
      </a-form-item>
      <a-form-item label="联系电话">
        <a-input
          v-decorator="[
            'contactMobile',
            {
              rules: [{ required: true, message: '联系电话不能为空' }],
              trigger: 'blur',
            },
          ]"
          placeholder="请输入手机号"
        />
      </a-form-item>
      <a-form-item label="纳税人识别号">
        <a-input
          v-decorator="[
            'taxpayerNo',
            {
              rules: [
                {
                  required: true,
                  message: '纳税人识别号不能为空',
                },
              ],
              trigger: 'blur',
            },
          ]"
          placeholder="请输入纳税人识别号"
          :read-only="true"
          class="custom-gray-input"
        />
      </a-form-item>
      <a-form-item label="纳税人性质">
        <a-select
          v-decorator="[
            'taxpayerNature',
            {
              rules: [{ required: true, message: '纳税人性质不能为空' }],
            },
          ]"
          placeholder="请选择纳税人性质"
        >
          <a-select-option
            v-for="item in taxpayerNature"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="会计准则类型">
        <a-select
          v-decorator="[
            'indexStandardType',
            {
              rules: [{ required: true, message: '会计准则类型不能为空' }],
            },
          ]"
          placeholder="请选择会计准则类型"
        >
          <a-select-option
            v-for="item in indexStandardType"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="注册类型">
        <a-select
          v-decorator="[
            'registrationType',
            {
              rules: [{ required: true, message: '注册类型不能为空' }],
            },
          ]"
          placeholder="请选择注册类型"
        >
          <a-select-option
            v-for="item in registrationType"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="所属行业">
      <a-select
          v-decorator="[
            'industry',
            {
              rules: [{ required: true, message: '所属行业不能为空' }],
            },
          ]"
          placeholder="请选择所属行业"
      >
        <a-select-option
            v-for="item in industry"
            :key="item.value"
            :value="item.value"
        >
          {{ item.label }}
        </a-select-option>
      </a-select>
    </a-form-item>
      <a-form-item label="客户端授权期限" >
        <a-select
            v-decorator="['period']"
            placeholder="请选择授权期限"
        >
          <a-select-option
              v-for="item in period"
              :key="item.value"
              :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="客户端使用截止日期">
        <a-input v-decorator="['expireDate']"  disabled
        />
      </a-form-item>
      <a-form-item label="财务软件名称">
        <a-select
            v-decorator="[
            'softIndex',
            {
              rules: [{ required: false, message: '' }],
            },
          ]"
            placeholder="请选择财务软件名称"
        >
          <a-select-option
              v-for="item in softIndex"
              :key="item.value"
              :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item  label="是否启用" >
        <a-checkbox
            value="clientType"
            style="font-weight: 900"
            v-decorator="['clientType', { valuePropName: 'checked' }]"
        >税智报
        </a-checkbox>
      </a-form-item>
    </a-form>



  </a-modal>
</template>
<script>
const levelNames = {
  0: "低",
  1: "低",
  2: "中",
  3: "强",
};
const levelClass = {
  0: "error",
  1: "error",
  2: "warning",
  3: "success",
};
const levelColor = {
  0: "#ff0000",
  1: "#ff0000",
  2: "#ff7e05",
  3: "#52c41a",
};
import pick from "lodash.pick";
import { editUser } from "@/api/user";
import { querySoftMapList } from "@/api/softmap";
import { queryExtendFieldServiceList } from "@/api/tenant";
import {
  indexStandardType,
  taxpayerNature,
  industry,
  registrationType,
  period,
} from "@/utils/dict";
export default {
  name: "UserModalEdit",
  data() {
    return {
      indexStandardType,
      taxpayerNature,
      industry,
      registrationType,
      period,
      visible: false,
      form: this.$form.createForm(this, { name: "form" }),
      confirmLoading: false,
      open: false,
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: "#FF0000",
      },
      expandFields: [],
      isU8: false,
      isU8c: false,
    };
  },
  methods: {
    async show(record) {
      debugger;
      this.visible = true;
      let res = await querySoftMapList();
      this.softIndex = res;
      await this.queryList();
      this.$nextTick(() => {
        this.form.setFieldsValue(
          Object.assign(
            pick(
              record,
              "id",
              "contactEmail",
              "password",
              "password2",
              "companyName",
              "contactPerson",
              "contactMobile",
              "taxpayerNo",
              "taxpayerNature",
              "indexStandardType",
              "registrationType",
               "period",
              "industry",
                "expireDate",
                "clientType",
                "softIndex",
            )
          )
        );
      });
    },
    async queryList() {
      this.loading = true;
      let res = await queryExtendFieldServiceList({
        page: 1,
        pageSize: 100,
      });
      if (res.status == 200) {
        this.expandFields = res.data.rows;
      } else {
        let msg = res.msg || res.message;
        let len = msg.length;
        this.$notification.error({
          message: "系统提示",
          description: len > 100 ? "系统错误，请联系管理员" : msg,
          duration: 4,
        });
      }
      this.loading = false;
    },

    handleSave() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          console.log(values);
          let params = Object.assign(
            {},
            pick(
              values,
                "id",
              "companyName",
              "contactPerson",
              "contactMobile",
              "indexStandardType",
              "taxpayerNature",
              "industry",
              "taxpayerType",
              "taxpayerNo",
                "clientType",
                "softIndex",
                "period",
                "expireDate",
              "registrationType"
            )
          );

          params.contactEmail = this.contactEmail;
          let res = await editUser(params);
          if (res.status == 200) {
            this.$message.success("修改成功");
            this.handleCancel();
            location.reload();
          } else {
            let msg = res.msg || res.message;
            let len = msg.length;
            this.$notification.error({
              message: "系统提示",
              description: len > 100 ? "系统错误，请联系管理员" : msg,
              duration: 4,
            });
          }
        }
      });
    },
    handleCancel() {
      this.state = {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: "#FF0000",
      };
      this.form.resetFields();
      this.visible = false;
    },
    openChange(status) {
      if (status) {
        this.open = true;
      } else {
        this.open = false;
      }
    },
    panelChange(value) {
      this.form.setFieldsValue({ since: String(value.year()) });
      this.open = false;
    },
    handleAccount(rule, value, callback) {
      if (value == "") {
        callback(new Error("账号不能为空"));
      } else {
        if (
          !new RegExp(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ).test(value)
        ) {
          callback(new Error("请输入正确格式的邮箱!"));
        } else {
          callback();
        }
      }
    },
    handlePasswordLevel(rule, value, callback) {
      if (value == "") {
        callback(new Error("密码不能为空"));
      }
      let level = 0;
      let reg =
        /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,}$/;
      if (!reg.test(value)) {
        callback(new Error("密码由8位数字、大小写字母和特殊符号组成!"));
      }
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++;
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++;
      }
      this.state.passwordLevel = level;
      this.state.percent = level * 30;
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100;
        }
        callback();
      } else {
        if (level === 0) {
          this.state.percent = 10;
        }
        callback(new Error("密码强度不够"));
      }
    },

    handlePasswordCheck(rule, value, callback) {
      let password = this.form.getFieldValue("password");
      if (value === undefined) {
        callback(new Error("请输入密码"));
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error("两次密码不一致"));
      }
      callback();
    },

    handlePasswordInputClick(flag) {
      this.state.passwordLevelChecked = flag;
    },
  },
  computed: {
    passwordLevelClass() {
      return levelClass[this.state.passwordLevel];
    },
    passwordLevelName() {
      return levelNames[this.state.passwordLevel];
    },
    passwordLevelColor() {
      return levelColor[this.state.passwordLevel];
    },
  },
};
</script>
<style lang="less" scoped>
.custom-gray-input {
  background-color: #e8e8e8; /* 较浅的灰色背景 */
  color: #888; /* 浅一点的灰色文本颜色 */
}
</style>
